export enum ItemState {
    Undefined = 'undefined',
    Draft = 'draft',
    Published = 'published',
    Unpublished = 'unpublished',
    Finished = 'finished',
}

//! in API ItemStateFilterParameter
export enum ItemStateFilter {
    All = 'All',
    Drafts = 'Drafts',
    Published = 'Published',
    Unpublished = 'Unpublished',
    Finished = 'Finished',
}
